import { gql } from '@apollo/client';

export default gql`
  mutation CheckinTickets($ticketNumbers: [String!], $bookingReference: String!) {
    checkinTickets(ticketNumbers: $ticketNumbers, bookingReference: $bookingReference) {
      reference
    }
  }
`;
